<header>
  <app-header></app-header>
  <app-navbar></app-navbar>
</header>
<body>
  <div class="card" style="margin: 20px; height: 100%;">
    <div class="card-header text-center" style="background-color: #be0c4d;">
      <h5 style="color: white;">Indicadores - Financiación de Vivienda</h5>
    </div>
    <div class="card-body">
      <div class="row" style="margin-top: 3px;">
        <div class="col-auto" style="text-align: center;">
          <button type="button" class="btn btn-secondary" (click)="RegresarOperativo()">Volver</button>
        </div>
        <div class="col-1" style="text-align: center;">
          <label style="margin-top: 4px;"><b>Periodo :</b></label>
        </div>
        <!--div class="col-auto">
          <select class="form-select" aria-label="Default select example" name="periodo" (change)="CosultarListaEstados($event.target.value)">
            <option  value="" selected="selected">Seleccionar</option>
            <option *ngFor="let p of ListaPeriodosConsultar" value="{{p.trimestre}}/{{p.anio}}">{{p.anio}} - {{p.trimestre}}</option>
          </select>
        </div-->
        <div class="col-auto">
          <select class="form-select" aria-label="Default select example" name="anio" (change)="CosultarDatos2()" [(ngModel)]="anioConsulta">
            <option  value="" selected="selected">Seleccionar</option>
            <option *ngFor="let p of aniosVigen" value="{{p}}">{{p}}</option>
          </select>
        </div>
        <div class="col-auto">
          <label for=""><b>-</b></label>
        </div>
        <div class="col-auto">
          <select class="form-select" aria-label="Default select example" name="trimestre" (change)="CosultarDatos2()" [(ngModel)]="consucutivoConsulta" >
            <option value="" selected="selected">Seleccionar</option>
            <option value="1">1</option>
            <option value="2">2</option>
            <option value="3">3</option>
            <option value="4">4</option>
            <option value="5">5</option>
            <option value="6">6</option>
            <option value="7">7</option>
            <option value="8">8</option>
            <option value="9">9</option>
            <option value="10">10</option>
            <option value="11">11</option>
            <option value="12">12</option>
          </select>
        </div>
      </div>
      <div class="row" style="margin-top: 3px;">
        <div class="col-3" style="text-align: center;margin: auto;">
          <label style="margin-top: 4px; font-size: large; color: black;"><b>Periodo {{consucutivoConsulta}} del {{anioConsulta}}</b></label>
        </div>
      </div>
      <div class="row justify-content-end" style="margin-right: 1%;">
        <a id="botonpdf" class="btn btn-light" (click)="descargarArchivoPDF()"></a>
        <a id="botonexcel" class="btn btn-light" (click)="descargarArchivoExcel()"></a>
      </div>
      <ul class="nav nav-tabs" id="myTab" role="tablist">
        <li class="nav-item" role="presentation">
          <button class="nav-link active" id="ic-tab" data-bs-toggle="tab" data-bs-target="#ic" type="button" role="tab" aria-controls="ic" aria-selected="true">
            <b style="color: black;">Cobertura (IC)</b>
          </button>
        </li>
        <li class="nav-item" role="presentation">
          <button class="nav-link" id="icif-tab" data-bs-toggle="tab" data-bs-target="#icif" type="button" role="tab" aria-controls="icif" aria-selected="false">
            <b style="color: black;">Calidad información (ICIF)</b>
          </button>
        </li>
        <li class="nav-item" role="presentation">
          <button class="nav-link" id="icri-tab" data-bs-toggle="tab" data-bs-target="#icri" type="button" role="tab" aria-controls="icri" aria-selected="false">
            <b style="color: black;">Critica logistica (ICRI)</b>
          </button>
        </li>
        <li class="nav-item" role="presentation">
          <button class="nav-link" id="icg-tab" data-bs-toggle="tab" data-bs-target="#icg" type="button" role="tab" aria-controls="icg" aria-selected="false">
            <b style="color: black;">Calidad global (ICG)</b>
          </button>
        </li>
      </ul>
      <div class="tab-content" id="myTabContent">
        <div class="tab-pane fade show active" id="ic" role="tabpanel" aria-labelledby="home-tab">
          <div class="row justify-content-center" id="grafica-ic">
            <div class="row"><div class="col-auto" style="margin: auto;"><h5>Indicador de Cobertura</h5></div></div>
            <br>
            <div class="row"><div class="col-auto" style="margin: auto;"><h6>Total fuentes = {{InformacionIndicadores.numeroTotalFtes}}</h6></div></div>
            <div class="row"><div class="col-auto" style="margin: auto;"><h6>IC = {{InformacionIndicadores.ic}}%</h6></div></div>
            <div class="row"><div class="col-auto" style="margin: auto;"><div id="myPlotlyDiv1" name="myPlotlyDiv1"></div></div></div>
            <div class="row">
              <div class="col" style="text-align: end;">
                <i class="fa fa-square" aria-hidden="true" style="color: rgb(18,30,153);"></i>
                <label> Número fuentes reportan</label>
              </div>
              <div class="col" style="text-align: start;">
                <i class="fa fa-square" aria-hidden="true" style="color: rgb(205,0,75);"></i>
                <label> Número fuentes no reportan</label>
              </div>
            </div>
          </div>
        </div>
        <div class="tab-pane fade" id="icif" role="tabpanel" aria-labelledby="profile-tab">
          <div class="row justify-content-center" id="grafica-icif_2">
            <div class="row"><div class="col-auto" style="margin: auto;"><h5>Indicador Calidad de Información</h5></div></div>
            <br>
            <div class="row"><div class="col-auto" style="margin: auto;"><h6>ICIF = {{InformacionIndicadores.icif}}%</h6></div></div>
            <div class="row"><div class="col-auto" style="margin: auto;"><div id="myPlotlyDiv2" name="myPlotlyDiv2"></div></div></div>
          </div>
        </div>
        <div class="tab-pane fade" id="icri" role="tabpanel" aria-labelledby="contact-tab">
          <div class="row justify-content-center" id="grafica-icri_3">
            <div class="row"><div class="col-auto" style="margin: auto;"><h5>Indicador Critica Logística</h5></div></div>
            <br>
            <div class="row"><div class="col-auto" style="margin: auto;"><h6>ICRI = {{InformacionIndicadores.icri}}%</h6></div></div>
            <div class="row"><div class="col-auto" style="margin: auto;"><div id="myPlotlyDiv3" name="myPlotlyDiv3"></div></div></div>
          </div>
        </div>
        <div class="tab-pane fade" id="icg" role="tabpanel" aria-labelledby="contact-tab">
          <div class="row justify-content-center" id="grafica-icg_4">
            <div class="row"><div class="col-auto" style="margin: auto;"><h5>Indicador Calidad Global</h5></div></div>
            <br>
            <div class="row"><div class="col-auto" style="margin: auto;"><h6>ICG = {{InformacionIndicadores.icg}}%</h6></div></div>
            <div class="row"><div class="col-auto" style="margin: auto;"><div id="myPlotlyDiv4" name="myPlotlyDiv4"></div></div></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</body>

<!--Modal Cargando-->
<button class="btn btn-primary btn-sm" #openmodalcargando data-toggle="modal"  data-target="#modal-cargando" style="visibility: hidden;" data-backdrop="static">ModCargar</button>
<div class="modal fade bd-example-modal-md" id="modal-cargando" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-md">
    <div class="modal-content">
      <div class="modal-body">
        <div class="card-body container-fluid">
          <br>
          <div class="row">
            <div class="col-auto" style="margin: auto;">
              <h5>Generando, espere un momento...</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close" #closemodacargando style="visibility: hidden;">
                <span aria-hidden="true"><i class="fas fa-times" style="color: white;"></i></span>
              </button>
            </div>
            <div class="d-flex justify-content-center">
              <div class="spinner-border text-danger" role="status" style="width: 60px; height: 60px;">
                <span class="visually-hidden">Loading...</span>
              </div>
            </div>
          </div>
          <br>
        </div>
      </div>
    </div>
  </div>
</div>
